// theme.js actualizado con Material 3 y colores personalizados
import { createTheme, alpha } from '@mui/material/styles';

// Colores personalizados - MOVIDO AL PRINCIPIO
const customColors = {
  primary: {
    main: '#1D4E89', // Azul oscuro
    light: '#3A6EA5', // Versión más clara del azul principal
    dark: '#0F3A6F', // Versión más oscura del azul principal
    contrastText: '#FFFFFF', // Texto blanco para contraste
  },
  secondary: {
    main: '#A7C7E7', // Azul claro
    light: '#C5DCEF', // Versión más clara del azul secundario
    dark: '#7FAAD3', // Versión más oscura del azul secundario
    contrastText: '#000000', // Texto negro para contraste
  },
  error: {
    main: '#D62828', // Rojo personalizado
    light: '#E45858', // Versión más clara del rojo
    dark: '#B01E1E', // Versión más oscura del rojo
    contrastText: '#FFFFFF', // Texto blanco para contraste
  },
  // Añadir color de acento rojo
  accent: {
    main: '#D62828',
    light: '#E45858',
    dark: '#B01E1E',
    contrastText: '#FFFFFF',
  }
};

// Definición completa de sombras
const shadows = [
  'none',
  '0px 2px 1px -1px rgba(0,0,0,0.1),0px 1px 1px 0px rgba(0,0,0,0.07),0px 1px 3px 0px rgba(0,0,0,0.06)',
  '0px 3px 1px -2px rgba(0,0,0,0.1),0px 2px 2px 0px rgba(0,0,0,0.07),0px 1px 5px 0px rgba(0,0,0,0.06)',
  '0px 3px 3px -2px rgba(0,0,0,0.1),0px 3px 4px 0px rgba(0,0,0,0.07),0px 1px 8px 0px rgba(0,0,0,0.06)',
  '0px 2px 4px -1px rgba(0,0,0,0.1),0px 4px 5px 0px rgba(0,0,0,0.07),0px 1px 10px 0px rgba(0,0,0,0.06)',
  '0px 3px 5px -1px rgba(0,0,0,0.1),0px 5px 8px 0px rgba(0,0,0,0.07),0px 1px 14px 0px rgba(0,0,0,0.06)',
  '0px 3px 5px -1px rgba(0,0,0,0.1),0px 6px 10px 0px rgba(0,0,0,0.07),0px 1px 18px 0px rgba(0,0,0,0.06)',
  '0px 4px 5px -2px rgba(0,0,0,0.1),0px 7px 10px 1px rgba(0,0,0,0.07),0px 2px 16px 1px rgba(0,0,0,0.06)',
  '0px 5px 5px -3px rgba(0,0,0,0.1),0px 8px 10px 1px rgba(0,0,0,0.07),0px 3px 14px 2px rgba(0,0,0,0.06)',
  '0px 5px 6px -3px rgba(0,0,0,0.1),0px 9px 12px 1px rgba(0,0,0,0.07),0px 3px 16px 2px rgba(0,0,0,0.06)',
  '0px 6px 6px -3px rgba(0,0,0,0.1),0px 10px 14px 1px rgba(0,0,0,0.07),0px 4px 18px 3px rgba(0,0,0,0.06)',
  '0px 6px 7px -4px rgba(0,0,0,0.1),0px 11px 15px 1px rgba(0,0,0,0.07),0px 4px 20px 3px rgba(0,0,0,0.06)',
  '0px 7px 8px -4px rgba(0,0,0,0.1),0px 12px 17px 2px rgba(0,0,0,0.07),0px 5px 22px 4px rgba(0,0,0,0.06)',
  '0px 7px 8px -4px rgba(0,0,0,0.1),0px 13px 19px 2px rgba(0,0,0,0.07),0px 5px 24px 4px rgba(0,0,0,0.06)',
  '0px 7px 9px -4px rgba(0,0,0,0.1),0px 14px 21px 2px rgba(0,0,0,0.07),0px 5px 26px 4px rgba(0,0,0,0.06)',
  '0px 8px 9px -5px rgba(0,0,0,0.1),0px 15px 22px 2px rgba(0,0,0,0.07),0px 6px 28px 5px rgba(0,0,0,0.06)',
  '0px 8px 10px -5px rgba(0,0,0,0.1),0px 16px 24px 2px rgba(0,0,0,0.07),0px 6px 30px 5px rgba(0,0,0,0.06)',
  '0px 8px 11px -5px rgba(0,0,0,0.1),0px 17px 26px 2px rgba(0,0,0,0.07),0px 6px 32px 5px rgba(0,0,0,0.06)',
  '0px 9px 11px -5px rgba(0,0,0,0.1),0px 18px 28px 2px rgba(0,0,0,0.07),0px 7px 34px 6px rgba(0,0,0,0.06)',
  '0px 9px 12px -6px rgba(0,0,0,0.1),0px 19px 29px 2px rgba(0,0,0,0.07),0px 7px 36px 6px rgba(0,0,0,0.06)',
  '0px 10px 13px -6px rgba(0,0,0,0.1),0px 20px 31px 3px rgba(0,0,0,0.07),0px 8px 38px 7px rgba(0,0,0,0.06)',
  '0px 10px 13px -6px rgba(0,0,0,0.1),0px 21px 33px 3px rgba(0,0,0,0.07),0px 8px 40px 7px rgba(0,0,0,0.06)',
  '0px 10px 14px -6px rgba(0,0,0,0.1),0px 22px 35px 3px rgba(0,0,0,0.07),0px 8px 42px 7px rgba(0,0,0,0.06)',
  '0px 11px 14px -7px rgba(0,0,0,0.1),0px 23px 36px 3px rgba(0,0,0,0.07),0px 9px 44px 8px rgba(0,0,0,0.06)',
  '0px 11px 15px -7px rgba(0,0,0,0.1),0px 24px 38px 3px rgba(0,0,0,0.07),0px 9px 46px 8px rgba(0,0,0,0.06)',
];

const globalScrollbarStyles = {
  // Para navegadores WebKit (Chrome, Safari, Edge)
  '*::-webkit-scrollbar': {
    width: '0px',
    height: '0px',
    background: 'transparent', // Opcional: asegura que no haya fondo
  },
  // Para Firefox
  '*': {
    scrollbarWidth: 'none',
  },
  // Para Internet Explorer y Edge (versiones antiguas)
  'body': {
    '-ms-overflow-style': 'none',
  }
};

// Función para crear el tema basado en el modo
export const createAppTheme = (mode) => {
  const isLight = mode === 'light';
  
  return createTheme({
    palette: {
      mode: mode, // 'light' o 'dark'
      primary: {
        main: customColors.primary.main,
        light: customColors.primary.light,
        dark: customColors.primary.dark,
        contrastText: customColors.primary.contrastText,
      },
      secondary: {
        main: customColors.secondary.main,
        light: customColors.secondary.light,
        dark: customColors.secondary.dark,
        contrastText: customColors.secondary.contrastText,
      },
      error: {
        main: customColors.error.main,
        light: customColors.error.light,
        dark: customColors.error.dark,
        contrastText: customColors.error.contrastText,
      },
      // Usar el rojo como color de advertencia
      warning: {
        main: customColors.accent.main,
        light: customColors.accent.light,
        dark: customColors.accent.dark,
        contrastText: customColors.accent.contrastText,
      },
      // Añadir color de acento a la paleta
      accent: customColors.accent,
      // Añadir color de fondo rojo para la AppBar
      appBar: {
        main: customColors.accent.main, // Color rojo principal
        dark: customColors.accent.dark, // Versión más oscura para hover o estados activos
        light: customColors.accent.light, // Versión más clara para elementos secundarios
        contrastText: customColors.accent.contrastText, // Texto blanco para contraste
      },
      info: {
        main: isLight ? '#0288d1' : '#29b6f6',
        light: isLight ? '#03a9f4' : '#4fc3f7',
        dark: isLight ? '#01579b' : '#0288d1',
        contrastText: isLight ? '#ffffff' : '#000000',
      },
      success: {
        main: isLight ? '#2e7d32' : '#66bb6a',
        light: isLight ? '#4caf50' : '#81c784',
        dark: isLight ? '#1b5e20' : '#388e3c',
        contrastText: isLight ? '#ffffff' : '#000000',
      },
      background: {
        default: isLight ? '#f5f7fa' : '#121212',
        paper: isLight ? '#ffffff' : '#1e1e1e',
        subtle: isLight ? '#f5f5f5' : '#272727', // Fondo sutil para tarjetas secundarias
      },
      text: {
        primary: isLight ? 'rgba(0, 0, 0, 0.87)' : 'rgba(255, 255, 255, 0.87)',
        secondary: isLight ? 'rgba(0, 0, 0, 0.6)' : 'rgba(255, 255, 255, 0.6)',
        disabled: isLight ? 'rgba(0, 0, 0, 0.38)' : 'rgba(255, 255, 255, 0.38)',
        accent: customColors.accent.main, // Texto en color acento
      },
      divider: isLight ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)',
      action: {
        active: isLight ? 'rgba(0, 0, 0, 0.54)' : 'rgba(255, 255, 255, 0.7)',
        hover: isLight ? 'rgba(0, 0, 0, 0.04)' : 'rgba(255, 255, 255, 0.08)',
        selected: isLight ? 'rgba(0, 0, 0, 0.08)' : 'rgba(255, 255, 255, 0.16)',
        disabled: isLight ? 'rgba(0, 0, 0, 0.26)' : 'rgba(255, 255, 255, 0.3)',
        disabledBackground: isLight ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)',
        focus: isLight ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)',
      },
    },
    typography: {
      fontFamily: '"Plus Jakarta Sans", "Manrope", "Montserrat", sans-serif',
      h1: {
        fontSize: '2.5rem',
        fontWeight: 700,
        letterSpacing: '-0.02em',
        lineHeight: 1.2,
      },
      h2: {
        fontSize: '2.2rem',
        fontWeight: 600,
        letterSpacing: '0.01em',
        lineHeight: 1.2,
      },
      h3: {
        fontSize: '1.8rem',
        fontWeight: 600,
        lineHeight: 1.3,
      },
      h4: {
        fontSize: '1.5rem',
        fontWeight: 600,
        lineHeight: 1.3,
      },
      h5: {
        fontSize: '1.2rem',
        fontWeight: 600,
        lineHeight: 1.4,
      },
      h6: {
        fontSize: '1rem',
        fontWeight: 600,
        lineHeight: 1.4,
      },
      body1: {
        fontFamily: '"Manrope", sans-serif',
        fontSize: '1rem',
        fontWeight: 400,
        lineHeight: 1.6,
      },
      body2: {
        fontSize: '0.875rem',
        lineHeight: 1.5,
      },
      button: {
        fontFamily: '"Montserrat", sans-serif',
        fontWeight: 600,
        fontSize: '0.875rem',
        textTransform: 'none',
        borderRadius: 8,
      },
      caption: {
        fontSize: '0.75rem',
        lineHeight: 1.4,
      },
      overline: {
        fontSize: '0.75rem',
        fontWeight: 500,
        textTransform: 'uppercase',
        letterSpacing: '0.08em',
      },
    },
    shape: {
      borderRadius: 16, // Material 3 usa bordes más redondeados
    },
    shadows: shadows,
    components: {
      MuiCssBaseline: {
        styleOverrides: { 
          ...globalScrollbarStyles,
          // Añadir soporte para transiciones suaves al cambiar de tema
          body: {
            transition: 'background-color 0.3s, color 0.3s',
          },
        },
      },
      MuiContainer: {
        styleOverrides: {
          root: {
            maxWidth: '100% !important',
            paddingLeft: '24px',
            paddingRight: '24px',
            '@media (min-width: 1280px)': {
              maxWidth: '100% !important',
            },
          },
        },
      },
      MuiAppBar: {
        styleOverrides: {
          root: {
            backgroundColor: customColors.primary.main, // Color rojo para todas las AppBars
            color: customColors.accent.contrastText, // Texto blanco para contraste
            boxShadow: '0px 2px 4px -1px rgba(0,0,0,0.1),0px 4px 5px 0px rgba(0,0,0,0.07),0px 1px 10px 0px rgba(0,0,0,0.06)',
          },
        },
        defaultProps: {
          elevation: 0, // Material 3 prefiere menos sombras
        },
      },
      MuiDrawer: {
        styleOverrides: {
          paper: {
            backgroundColor: mode === 'light' ? '#ffffff' : '#1e1e1e',
            borderRight: `1px solid ${mode === 'light' ? 'rgba(0, 0, 0, 0.08)' : 'rgba(255, 255, 255, 0.08)'}`,
          },
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            boxShadow: mode === 'light' 
              ? '0px 2px 4px -1px rgba(0,0,0,0.06),0px 4px 5px 0px rgba(0,0,0,0.05),0px 1px 10px 0px rgba(0,0,0,0.04)'
              : '0px 2px 4px -1px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 10px 0px rgba(0,0,0,0.12)',
            borderRadius: '16px', // Material 3 usa bordes más redondeados
          },
        },
        defaultProps: {
          elevation: 0, // Material 3 prefiere menos sombras
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: 'none',
            borderRadius: '20px', // Material 3 usa botones más redondeados
            padding: '10px 24px',
            boxShadow: 'none',
            '&:hover': {
              boxShadow: '0px 2px 4px -1px rgba(0,0,0,0.1),0px 4px 5px 0px rgba(0,0,0,0.07)',
            },
          },
          contained: {
            boxShadow: mode === 'light' 
              ? '0px 1px 3px 0px rgba(0,0,0,0.1),0px 1px 2px 0px rgba(0,0,0,0.06)'
              : '0px 2px 4px -1px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14)',
          },
          outlined: {
            borderWidth: '1px',
          },
          text: {
            padding: '10px 16px',
          },
        },
      MuiMenuItem: {
        styleOverrides: {
          root: {
            '&.Mui-selected': {
              backgroundColor: alpha('#1D4E89', 0.12), // usa tu primary.main
            },
            '&.Mui-selected:hover': {
              backgroundColor: alpha('#1D4E89', 0.18),
            },
          },
        },
      },  
        // Variantes de botones
        variants: [
          {
            props: { variant: 'tonal' },
            style: {
              backgroundColor: mode === 'light' ? alpha(customColors.primary.main, 0.1) : alpha(customColors.primary.light, 0.1),
              color: mode === 'light' ? customColors.primary.main : customColors.primary.light,
              '&:hover': {
                backgroundColor: mode === 'light' ? alpha(customColors.primary.main, 0.2) : alpha(customColors.primary.light, 0.2),
              },
            },
          },
          // Variante de botón con color acento (rojo)
          {
            props: { variant: 'accent' },
            style: {
              backgroundColor: customColors.accent.main,
              color: customColors.accent.contrastText,
              '&:hover': {
                backgroundColor: customColors.accent.dark,
              },
            },
          },
          // Variante de botón con borde de color acento (rojo)
          {
            props: { variant: 'outlinedAccent' },
            style: {
              border: `1px solid ${customColors.accent.main}`,
              color: customColors.accent.main,
              '&:hover': {
                backgroundColor: alpha(customColors.accent.main, 0.1),
              },
            },
          },
          // Variante de botón texto de color acento (rojo)
          {
            props: { variant: 'textAccent' },
            style: {
              color: customColors.accent.main,
              '&:hover': {
                backgroundColor: alpha(customColors.accent.main, 0.1),
              },
            },
          },
        ],
      },
      // Resto de los componentes...
      MuiTableCell: {
        styleOverrides: {
          root: {
            padding: '16px', // Más espacio para reducir la fatiga visual
            borderBottom: mode === 'light' 
              ? '1px solid rgba(0, 0, 0, 0.06)' 
              : '1px solid rgba(255, 255, 255, 0.06)',
          },
          head: {
            fontFamily: '"Plus Jakarta Sans", sans-serif',
            fontWeight: 700,
            backgroundColor: mode === 'light' ? '#f8fafc' : '#1a1a1a',
            color: mode === 'light' ? customColors.primary.main : customColors.primary.light,
            textTransform: 'uppercase',
            fontSize: '0.75rem',
            letterSpacing: '0.05em',
          },
          body: {
            fontFamily: '"Manrope", sans-serif',
            fontSize: '0.875rem',
            color: mode === 'light' ? 'rgba(0, 0, 0, 0.87)' : 'rgba(255, 255, 255, 0.87)',
          },
        },
      },
      MuiTextField: {
        styleOverrides: {
          root: {
            '& .MuiInputBase-root': {
              borderRadius: '12px', // Material 3 usa campos de texto más redondeados
            },
          },
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            borderRadius: '12px',
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderWidth: '2px', // Material 3 usa bordes más gruesos para el estado de foco
            },
          },
          notchedOutline: {
            borderColor: mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)',
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          rounded: {
            borderRadius: '16px', // Material 3 usa bordes más redondeados
          },
          elevation1: {
            boxShadow: mode === 'light'
              ? '0px 1px 3px 0px rgba(0,0,0,0.1),0px 1px 2px 0px rgba(0,0,0,0.06)'
              : '0px 2px 4px -1px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14)',
          },
        },
        defaultProps: {
          elevation: 0, // Material 3 prefiere menos sombras
        },
      },
      MuiChip: {
        styleOverrides: {
          root: {
            borderRadius: '16px', // Material 3 usa chips más redondeados
          },
          filled: {
            backgroundColor: mode === 'light' ? alpha(customColors.primary.main, 0.1) : alpha(customColors.primary.light, 0.1),
            color: mode === 'light' ? customColors.primary.main : customColors.primary.light,
            '&:hover': {
              backgroundColor: mode === 'light' ? alpha(customColors.primary.main, 0.2) : alpha(customColors.primary.light, 0.2),
            },
          },
        },
        variants: [
          {
            props: { color: 'accent' },
            style: {
              backgroundColor: alpha(customColors.accent.main, 0.1),
              color: customColors.accent.main,
              '&:hover': {
                backgroundColor: alpha(customColors.accent.main, 0.2),
              },
            },
          },
        ],
      },
      // Resto de los componentes...
      // Estilos específicos para el modo oscuro
      ...(mode === 'dark' && {
        MuiOutlinedInput: {
          styleOverrides: {
            root: {
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: 'rgba(255, 255, 255, 0.23)',
              },
              '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: 'rgba(255, 255, 255, 0.4)',
              },
            },
          },
        },
        MuiChip: {
          styleOverrides: {
            outlined: {
              borderColor: 'rgba(255, 255, 255, 0.23)',
            },
          },
        },
        MuiPaper: {
          styleOverrides: {
            root: {
              backgroundImage: 'none', // Eliminar el patrón de fondo en modo oscuro
            },
          },
        },
      }),
    },
  });
};

// Exportar el tema predeterminado (modo claro)
const theme = createAppTheme('light');
export default theme;
